






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Producer } from '@/modules/Producer/interfaces/producer'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class ProducerDetailAdditional extends Vue {
  @Prop({ type: Object as () => Producer }) readonly producer!: Producer
}
